var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8927_3834",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8927_3834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13.859L14.4487 10.9103H8.55128L11.5 13.859ZM11.5032 20.125C10.3105 20.125 9.18919 19.8987 8.13922 19.446C7.08925 18.9934 6.17592 18.3791 5.39923 17.6031C4.62254 16.8272 4.00767 15.9147 3.5546 14.8657C3.10153 13.8167 2.875 12.6959 2.875 11.5032C2.875 10.3105 3.10132 9.18919 3.55396 8.13922C4.00661 7.08925 4.62092 6.17592 5.39688 5.39923C6.17284 4.62255 7.08531 4.00767 8.13429 3.5546C9.18328 3.10153 10.3041 2.875 11.4968 2.875C12.6895 2.875 13.8108 3.10132 14.8608 3.55395C15.9107 4.00661 16.8241 4.62092 17.6008 5.39688C18.3775 6.17284 18.9923 7.08531 19.4454 8.13429C19.8985 9.18328 20.125 10.3041 20.125 11.4968C20.125 12.6895 19.8987 13.8108 19.446 14.8608C18.9934 15.9107 18.3791 16.8241 17.6031 17.6008C16.8272 18.3775 15.9147 18.9923 14.8657 19.4454C13.8167 19.8985 12.6959 20.125 11.5032 20.125ZM11.5 19.1667C13.6403 19.1667 15.4531 18.424 16.9385 16.9385C18.424 15.4531 19.1667 13.6403 19.1667 11.5C19.1667 9.35972 18.424 7.54688 16.9385 6.06146C15.4531 4.57604 13.6403 3.83333 11.5 3.83333C9.35972 3.83333 7.54688 4.57604 6.06146 6.06146C4.57604 7.54688 3.83333 9.35972 3.83333 11.5C3.83333 13.6403 4.57604 15.4531 6.06146 16.9385C7.54688 18.424 9.35972 19.1667 11.5 19.1667Z",
    fill: "#7A7A7A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDown);
export default __webpack_public_path__ + "static/media/drop-down.07a1ce4761465cbc3d9b05a246fb6a1a.svg";
export { ForwardRef as ReactComponent };